export const AUTH_ROUTE = '/';
export const USERS_ROUTE = '/users';
export const EXPORT_R00T_ROUTE = '/export';
export const EXPORT_PATIENTS_ROUTE = '/export/patients';
export const EXPORT_EVENTS_ROUTE = '/export/events';
export const EXPORT_GLUCOMETERS_ROUTE = '/export/glucometers';
export const VERSIONING_ROUTE = '/versioning';
export const PUSH_NOTIFICATIONS_ROUTE = '/push-notifications';
